import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, HeartIcon, ClockIcon, CheckCircle2Icon, ArrowRightIcon, StarIcon } from 'lucide-react';
export function MarketingLandingPage() {
  return <div className="min-h-screen bg-white font-sans text-[#0B1220] flex flex-col" data-id="element-4406">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-4407">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-4408">
          <Link to="/marketing" className="flex-shrink-0" data-id="element-4409">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6 md:h-7" data-id="element-4410" />
          </Link>
          <Link to="/onboarding" className="bg-[#0EB4CC] text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-[#0ca3b8] transition-colors shadow-sm" data-id="element-4411">
            Get Started
          </Link>
        </div>
      </header>

      <main className="flex-1 flex flex-col" data-id="element-4412">
        {/* Hero Section */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24 relative overflow-hidden" data-id="element-4413">
          <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-4414">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1F0648] mb-6 leading-[1.1] tracking-tight" data-id="element-4415">
              Your parents deserve better than a frustrated family IT guy.
            </h1>
            <p className="text-lg md:text-xl text-[#0B1220] mb-8 leading-relaxed max-w-2xl mx-auto opacity-90" data-id="element-4416">
              Caveo is the first digital safety platform that actually teaches
              your parents how to stay safe online, so you can stop fixing their
              Wi-Fi and start enjoying your weekends again.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-4417">
              <Link to="/onboarding" className="w-full sm:w-auto bg-[#1F0648] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2d096b] transition-all shadow-lg flex items-center justify-center gap-2" data-id="element-4418">
                Start free 7-day trial
                <ArrowRightIcon size={20} data-id="element-4419" />
              </Link>
              <p className="text-sm text-[#1F0648] font-medium opacity-75 sm:hidden mt-2" data-id="element-4420">
                No credit card required
              </p>
            </div>
            <div className="hidden sm:flex items-center justify-center gap-2 mt-6 text-sm text-[#1F0648] font-medium opacity-80" data-id="element-4421">
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4422" /> Cancel
              anytime
              <span className="mx-2" data-id="element-4423">•</span>
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4424" /> Takes 3
              minutes
            </div>
          </div>

          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-4425">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#0EB4CC] rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-4426"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-[#1F0648] rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-4427"></div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="bg-white px-4 py-16 md:py-24" data-id="element-4428">
          <div className="max-w-7xl mx-auto" data-id="element-4429">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4430">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-4" data-id="element-4431">
                Peace of mind for them. Time back for you.
              </h2>
              <p className="text-[#0B1220] opacity-80 text-lg" data-id="element-4432">
                We replace confusing tech jargon with plain-English guidance
                that builds genuine digital confidence.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4433">
              {/* Benefit 1 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4434">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4435">
                  <ShieldCheckIcon size={28} className="text-[#1F0648]" data-id="element-4436" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4437">
                  Stop the Scams
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4438">
                  Proactive education helps your parents spot phishing, fake
                  alerts, and social engineering before they click.
                </p>
              </div>

              {/* Benefit 2 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4439">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4440">
                  <ClockIcon size={28} className="text-[#1F0648]" data-id="element-4441" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4442">
                  Reclaim Your Time
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4443">
                  No more emergency tech support calls during dinner. We handle
                  the repetitive questions so you don't have to.
                </p>
              </div>

              {/* Benefit 3 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4444">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4445">
                  <HeartIcon size={28} className="text-[#1F0648]" data-id="element-4446" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4447">
                  Built for Boomers
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4448">
                  Zero jargon. No downloads required. Just clear, step-by-step
                  guidance designed specifically for older adults.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="bg-[#1F0648] px-4 py-16 md:py-24 text-white" data-id="element-4449">
          <div className="max-w-7xl mx-auto" data-id="element-4450">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4451">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-4452">
                How Caveo works
              </h2>
              <p className="text-gray-300 text-lg" data-id="element-4453">
                A simple, dignified approach to digital safety.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-4454">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-[#2d096b] z-0" data-id="element-4455"></div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4456">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4457">
                  1
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4458">
                  Take the Assessment
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4459">
                  A quick 3-minute quiz identifies your family's specific
                  vulnerabilities and current tech setup.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4460">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4461">
                  2
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4462">
                  Get a Custom Plan
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4463">
                  We generate a personalized curriculum focused only on what
                  they actually need to know.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4464">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4465">
                  3
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4466">
                  Learn & Secure
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4467">
                  They complete bite-sized, jargon-free lessons that build real
                  confidence and secure their accounts.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24" data-id="element-4468">
          <div className="max-w-7xl mx-auto" data-id="element-4469">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] text-center mb-12" data-id="element-4470">
              Loved by families
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-4471">
              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4472">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4473">
                  <StarIcon size={20} fill="currentColor" data-id="element-4474" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4475" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4476" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4477" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4478" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4479">
                  "My dad almost lost $4,000 to a phishing scam last year. Since
                  starting Caveo, he actually understands what to look for. And
                  the best part? He hasn't called me to fix his iPad in two
                  months."
                </p>
                <div className="flex items-center gap-3" data-id="element-4480">
                  <div className="w-10 h-10 bg-[#1F0648] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4481">
                    S
                  </div>
                  <div data-id="element-4482">
                    <p className="font-bold text-[#1F0648]" data-id="element-4483">Sarah M.</p>
                    <p className="text-sm text-gray-500" data-id="element-4484">
                      Daughter & "Family IT Dept"
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4485">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4486">
                  <StarIcon size={20} fill="currentColor" data-id="element-4487" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4488" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4489" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4490" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4491" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4492">
                  "I was skeptical that an app could teach my 72-year-old mom
                  about password managers, but the plain-English approach really
                  works. It treats her with dignity instead of talking down to
                  her."
                </p>
                <div className="flex items-center gap-3" data-id="element-4493">
                  <div className="w-10 h-10 bg-[#0EB4CC] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4494">
                    M
                  </div>
                  <div data-id="element-4495">
                    <p className="font-bold text-[#1F0648]" data-id="element-4496">Michael T.</p>
                    <p className="text-sm text-gray-500" data-id="element-4497">Son & Caregiver</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Teaser / Final CTA */}
        <section className="bg-white px-4 py-16 md:py-24 text-center" data-id="element-4498">
          <div className="max-w-3xl mx-auto" data-id="element-4499">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-6" data-id="element-4500">
              Protect your family today
            </h2>
            <p className="text-lg text-[#0B1220] opacity-80 mb-8 max-w-xl mx-auto" data-id="element-4501">
              Get comprehensive digital safety education for the whole family
              for less than the cost of one tech support visit.
            </p>

            <div className="bg-[#f8f9fa] rounded-2xl p-8 max-w-md mx-auto border border-gray-200 mb-8" data-id="element-4502">
              <h3 className="text-2xl font-bold text-[#1F0648] mb-2" data-id="element-4503">
                Family Plan
              </h3>
              <div className="flex items-end justify-center gap-1 mb-6" data-id="element-4504">
                <span className="text-4xl font-extrabold text-[#0B1220]" data-id="element-4505">
                  $19.99
                </span>
                <span className="text-gray-500 mb-1" data-id="element-4506">/month</span>
              </div>
              <ul className="text-left space-y-3 mb-8" data-id="element-4507">
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4508">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4509" />
                  <span data-id="element-4510">Up to 5 family members</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4511">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4512" />
                  <span data-id="element-4513">Full curriculum access</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4514">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4515" />
                  <span data-id="element-4516">Family dashboard & alerts</span>
                </li>
              </ul>
              <Link to="/onboarding" className="block w-full bg-[#0EB4CC] text-white px-6 py-4 rounded-full font-bold text-lg hover:bg-[#0ca3b8] transition-colors shadow-md" data-id="element-4517">
                Start 7-Day Free Trial
              </Link>
            </div>
            <p className="text-sm text-gray-500" data-id="element-4518">
              Cancel anytime. No commitment.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1F0648] text-white py-12 px-4 border-t border-[#2d096b]" data-id="element-4519">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-4520">
          <div className="flex items-center gap-2" data-id="element-4521">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-6 opacity-90" data-id="element-4522" />
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-4523">
            <Link to="/about-us" className="hover:text-white transition-colors" data-id="element-4524">
              About
            </Link>
            <Link to="/pricing" className="hover:text-white transition-colors" data-id="element-4525">
              Pricing
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-4526">
              Privacy Policy
            </Link>
          </div>
          <div className="text-sm text-gray-500" data-id="element-4527">
            &copy; {new Date().getFullYear()} Caveo. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}